import ROLES from "data/Roles";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Drawer } from "../shared/components/Drawer";
import { Title } from "../shared/components/Title";
import { Icon } from "../shared/components/core/Icon";
import { Permissions } from "../shared/tools/AccessManager";
import { EnvironmentStorage } from "../shared/tools/EnvironmentStorage";
import { UserStorage } from "../shared/tools/UserStorage";
import styles from "../styles/settings.module.scss";
export default function Settings() {
  const [openAlert, setOpenAlert] = useState(false);

  const environment = EnvironmentStorage.getEnvironment();
  let userRole = UserStorage.getLoggedUser()?.role;

  const settings = [
    {
      name: "Cardápio",
      show: true,
      icon: <Icon name="book-open" />,
      visible: true,
      path: "cardapio",
      permissions: [
        Permissions.CONFIGURATION_CATALOG_PLACES,
        Permissions.CONFIGURATION_CATALOG_SHUTDOWN,
        Permissions.CONFIGURATION_CATALOG_UPDATE,
        Permissions.CONFIGURATION_CATALOG_TAGS,
        Permissions.CONFIGURATION_SCHEDULE_UPDATE,
      ],
      enabled: userRole !== ROLES.MARKETING,
    },
    {
      name: "Personalização do Início",
      show: true,
      icon: <Icon name="palette" />,
      visible: true,
      path: "personalizacao-do-inicio",
      enabled: [
        ROLES.SUPPORT,
        ROLES.ADMIN,
        ROLES.MARKETING,
        ROLES.MANAGER,
        ROLES.SAC,
      ].includes(userRole),
    },
    {
      name: "Agendamento",
      show: true,
      visible: !(environment.type == "BRAND"),
      icon: <Icon name="calendar-day" light />,
      path: "agendamento",
      enabled: userRole !== ROLES.MARKETING,
    },
    {
      name: "Horários de atendimento",
      show: true,
      visible: !(environment.type == "BRAND"),
      icon: <Icon name="clock" />,
      path: "horarios-de-atendimento",
      permissions: [
        Permissions.CONFIGURATION_WORKING_TIME_UPDATE,
        Permissions.CONFIGURATION_WORKING_TIME_ACTIVE_DAY,
      ],
      enabled: userRole !== ROLES.MARKETING,
    },
    {
      name: "Localização",
      show: true,
      visible: !(environment.type == "BRAND"),
      icon: <Icon name="map-marker-alt" />,
      path: "localizacao",
      permissions: [Permissions.CONFIGURATION_LOCALIZATION],
      enabled: ![ROLES.SHOPKEEPER, ROLES.MARKETING].includes(userRole),
    },
    {
      name: "Regiões de entrega",
      show: true,
      visible: !(environment.type == "BRAND"),
      icon: <Icon name="map" />,
      path: "regioes-de-entrega",
      permissions: [
        Permissions.CONFIGURATION_DELIVERY_REGIONS_UPDATE,
        Permissions.CONFIGURATION_DELIVERY_REGIONS_TIME_UPDATE,
      ],
      enabled: userRole !== ROLES.MARKETING,
    },
    // {
    //   name: "Agendamento",
    //   show: true,
    //   visible: !(environment.type == "BRAND"),
    //   icon: <Icon name="calendar" />,
    //   path: "agendamento",
    // },
    {
      name: `Pagamento na entrega`,
      show: true,
      visible: !(environment.type == "BRAND"),
      icon: <Icon name="credit-card-blank" />,
      path: "pagamento-na-entrega",
      permissions: [Permissions.CONFIGURATION_OFFLINE_PAYMENT],
      enabled: userRole !== ROLES.MARKETING,
    },
    {
      name: "Configurações ocultas",
      show: UserStorage.isGodMode,
      visible: true,
      icon: <Icon name="eye-slash" light />,
      path: "secretas",
      permissions: [Permissions.CONFIGURATION_OTHERS],
      enabled: ![ROLES.SHOPKEEPER, ROLES.MARKETING].includes(userRole),
    },
    {
      name: "Configurações gerais",
      show: true,
      visible: true,
      icon: <Icon name="cloud" light />,
      path: "sistema",
      permissions: [Permissions.CONFIGURATION_OTHERS],
      enabled: ![ROLES.SHOPKEEPER, ROLES.MARKETING].includes(userRole),
    },
    // {
    //   name: "Configurações de segurança",
    //   show: true,
    //   visible: true,
    //   icon: <Icon name="lock" />,
    //   path: "seguranca",
    //   permissions: [Permissions.CONFIGURATION_OTHERS],
    //   enabled: ![ROLES.SHOPKEEPER, ROLES.MARKETING].includes(userRole),
    // },
    // {
    //   name: "Agendamentos",
    //   show: true,
    //   visible: true,
    //   icon: <Icon name="clock" />,
    //   path: "agendamento",
    //   permissions: [Permissions.CONFIGURATION_SCHEDULE_UPDATE],
    //   enabled: ![ROLES.SHOPKEEPER, ROLES.MARKETING].includes(userRole),],
    // },
    {
      name: "Mesas",
      show: true,
      visible: true,
      icon: <Icon name="table-cells" light />,
      path: "mesas",
      permissions: [Permissions.CONFIGURATION_OTHERS],
      enabled: ![ROLES.SHOPKEEPER, ROLES.MARKETING].includes(userRole),
    },
    {
      name: "Banners",
      show: true,
      visible: true,
      icon: <Icon name="image-polaroid" light />,
      path: "banners",
      permissions: [Permissions.CONFIGURATION_OTHERS],
      enabled: true,
    },
  ];

  const getSubtitle = () => {
    if (environment?.brand)
      return (
        `${environment.brand.name} - ${environment.name}` +
        (environment.active === false ? " (Inativa)" : "")
      );
    return environment?.name;
  };

  return (
    <div className={styles.settingsContainer}>
      <Title title="Configurações" subtitle={getSubtitle()} />

      <div className={styles.settings}>
        {settings
          .filter((s) => !!s.show && s.enabled)
          .map((setting, index) => {
            return (
              <>
                {setting.visible && (
                  <Link
                    to={setting.visible !== false && setting.path}
                    key={index}
                  >
                    <div className={styles.setting} style={{ opacity: 1 }}>
                      <div className={styles.icon}>{setting.icon}</div>
                      <p>{setting.name}</p>
                    </div>
                  </Link>
                )}

                {!setting.visible && (
                  <div
                    className={styles.setting}
                    style={{ opacity: 0.5 }}
                    onClick={() => setOpenAlert(true)}
                  >
                    <div className={styles.icon}>{setting.icon}</div>
                    <p>{setting.name}</p>
                  </div>
                )}
              </>
            );
          })}
      </div>

      <Drawer
        visible={openAlert}
        onClose={() => setOpenAlert(false)}
        direction="center"
        title="Atenção"
        closeButton={false}
      >
        <p className={styles.message}>
          Esta página é acessível somente no modo unidade.
        </p>
      </Drawer>
    </div>
  );
}
